import { Component, OnInit } from '@angular/core';
import { ShoopingService } from '../shooping.service';
import { Products } from '../shooping.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.scss']
})
export class ProductCategoryComponent implements OnInit {
  products: Products[] = [];
  favProduct = [];
  categories:any;
  routerPath: any;
  searchModel: string;


  constructor(private shoopingService: ShoopingService, private spinnerService: NgxSpinnerService,
     private notifyService : NotificationService, private route: ActivatedRoute) {
      this.route.queryParams.subscribe(res => {
        this.routerPath = res['category'];
        console.log(this.routerPath)
      })
     };

  ngOnInit(): void {
    this.showSpinner();
    this.fetchProductCategoryBase();
    this.getFavProducts();
  }

  updateSearchModel(value) {
    this.searchModel = value;
  }

  fetchProductCategoryBase() {
    this.shoopingService.getProductsByCategories(this.routerPath).subscribe(res => {
      res.forEach(item => item.price = Math.floor(item.price));
      this.products = res;
    });
  }

  getFavProducts() {
    this.favProduct = JSON.parse(localStorage.getItem('favProduct'));
  }

  public showSpinner(): void {
    this.spinnerService.show();
    if(this.products.length > 0){
      this.spinnerService.hide();
    }
  }

  addFavourite(product){
    this.checkFavourite(product);
    localStorage.setItem('favProduct', JSON.stringify(this.favProduct));
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }


  checkFavourite(product) {
    let findProduct = this.favProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.favProduct.push(product);
      this.showToasterSuccess('Product added in the Favourite List!');
    } else {
      let removeProduct = this.favProduct.filter(item => item.id !== product.id);
      this.favProduct = removeProduct;
      this.showToasterSuccess('Product removed in the Favourite List!');
    }
  }
}
